import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAccountId } from '../../redux/reducers/account/account';
import { getAdminImportAccess } from '../../services/network/adminImport';

const cache = new Map();

const checkAccess = (accountId) => {
    if (!cache.has(accountId)) {
        cache.set(
            accountId,
            getAdminImportAccess()
                .then((res) => Boolean(res?.admin))
                .catch((err) => {
                    if (err?.error !== 'forbidden') cache.delete(accountId);
                    return false;
                }),
        );
    }
    return cache.get(accountId);
};

export const useIsAdmin = () => {
    const accountId = useSelector(selectAccountId);
    const [isAdmin, setIsAdmin] = useState(null);

    useEffect(() => {
        if (!accountId) {
            setIsAdmin(false);
            return undefined;
        }
        let active = true;
        checkAccess(accountId).then((value) => {
            if (active) setIsAdmin(value);
        });
        return () => {
            active = false;
        };
    }, [accountId]);

    return isAdmin;
};
